import { createFileRoute } from '@tanstack/react-router'

import { AuthErrorView } from '@/features/auth/pages'
import { AuthModes } from '@/features/auth/policy'
import { useTenantOptional } from '@/shared/contexts/TenantContext'

type AuthErrorSearch = {
  error?: string
  callbackUrl?: string
  message?: string
}

export const Route = createFileRoute('/_event/auth/error')({
  staticData: {
    auth: {
      mode: AuthModes.BOOTSTRAP,
      requiresDigitalProductId: false
    }
  },
  validateSearch: (search: Record<string, unknown>): AuthErrorSearch => ({
    error: typeof search.error === 'string' ? search.error : undefined,
    callbackUrl:
      typeof search.callbackUrl === 'string' ? search.callbackUrl : '',
    message: typeof search.message === 'string' ? search.message : ''
  }),
  component: TenantAuthErrorRoute
})

function TenantAuthErrorRoute() {
  const tenant = useTenantOptional()
  const { error, callbackUrl, message } = Route.useSearch()

  return (
    <AuthErrorView
      errorCode={error || 'default'}
      callbackUrl={callbackUrl}
      message={message}
      referer={typeof document !== 'undefined' ? document.referrer : ''}
      digitalProductId={tenant?.digitalProductId ?? undefined}
    />
  )
}
